import { getHomeSceneExpandedPreference } from '@/common/app-preference'

// 页面公用信息仓库
const publicinfo = {
  state: {
    ////用户的公共变量仓库  ///使用 this.$store.state.userinfo(子模组，没有时不写).userId（用户变量）
    title: '', ///..用来确定控制页面当前活跃的页面
    controlPageType: '', //定义导航栏样式的变量 （暂时未用）
    ///// 页面未展开时，各个区域未显示的数据个数，用来判断是否显示展示和收起按钮（展开收起功能块）
    homeSenceCount: 0, //常用页面的场景区域
    showHomeSenceText: getHomeSceneExpandedPreference() ? '收起' : '展开', //默认一个属性
    // homeDeviceCount:0, //常用页面的设备区域  （暂时未用）
    regionSenceCount: 0, //区域页面的场景区域
    showRegionSenceText: '展开', //默认一个属性
    // regionDeviceCount:0, //区域页面的设备区域  （暂时未用）
    regionShowPage: {
      ////用来存储判断当前区域页面 要显示的是哪个区域
      name: '全部区域',
      id: ''
    },
    ////设置管理进入之前的页面路径，用于设置页面右上角的返回
    configReturnPath: '/controlpage/home',
    homeSceneCount: 0, /////常用页面的场景要显示的总个数，存起来是为了进行变化检测
    regionSceneCount: 0, /////常用页面的场景要显示的总个数，存起来是为了进行变化检测
    // ServeData: {
    //   ////服务器请求到的页面需要展示的数据，主要用来界面管理的排序
    //   deviceList: [],
    //   sceneList: []
    // },
    homeServeData: {
      ////服务器器请求到的常用页面的数据，主要用来页面数据状态更新
      deviceList: [],
      sceneList: []
    },
    regionServeData: {
      ////服务器器请求到的区域页面的数据，主要用来页面数据状态更新
      deviceList: [],
      sceneList: []
    },
    objData: {} //二级页面打开之后存储的数据 用于二级页面的实时状态更新 20200405添加
  },
  mutations: {
    ///同步提交信息的方法，组件中的使用 this.$store.commit('updataTitle（定义的方法名）' , '传入的参数')
    updataTitle(state, title) {
      state.title = title
    },
    updataControlPageType(state, controlPageType) {
      //定义导航栏样式的变量
      state.controlPageType = controlPageType
    },
    updataRegionSenceCount(state, regionSenceCount) {
      //提交区域页面的剩余未显示的数量 （展开收起功能块）
      state.regionSenceCount = regionSenceCount
    },
    updataShowRegionSenceText(state, showRegionSenceText) {
      //（展开收起功能块）
      state.showRegionSenceText = showRegionSenceText
    },
    updataHomeSenceCount(state, homeSenceCount) {
      //提交区域页面的剩余未显示的数量 （展开收起功能块）
      state.homeSenceCount = homeSenceCount
    },
    updataShowHomeSenceText(state, showHomeSenceText) {
      //（展开收起功能块）
      state.showHomeSenceText = showHomeSenceText
    },
    updataRegionShowPage(state, regionShowPage) {
      //（区域显示）
      state.regionShowPage.id = regionShowPage.regionId
      state.regionShowPage.name = regionShowPage.regionName
    },
    updataConfigReturnPath(state, configReturnPath) {
      ////设置管理进入之前的页面路径，用于设置页面右上角的返回
      state.configReturnPath = configReturnPath
    },
    updatahomeSceneCount(state, homeSceneCount) {
      ////（展开收起功能块）
      state.homeSceneCount = homeSceneCount
    },
    updataregionSceneCount(state, regionSceneCount) {
      ////（展开收起功能块）
      state.regionSceneCount = regionSceneCount
    },
    // updataServeData(state, ServeData) {
    //   state.ServeData = ServeData
    // },
    // updataServeDatadeviceList(state, deviceList) {
    //   state.ServeData.deviceList = deviceList
    // },
    // updataServeDatasceneList(state, sceneList) {
    //   state.ServeData.sceneList = sceneList
    // },
    updataregionServeData(state, regionServeData) {
      state.regionServeData = regionServeData
    },
    updataregionServeDatadeviceList(state, deviceList) {
      state.regionServeData.deviceList = deviceList
    },
    updataregionServeDatasceneList(state, sceneList) {
      state.regionServeData.sceneList = sceneList
    },
    updatahomeServeData(state, homeServeData) {
      state.homeServeData = homeServeData
    },
    updatahomeServeDatadeviceList(state, deviceList) {
      state.homeServeData.deviceList = deviceList
    },
    updatahomeServeDatasceneList(state, sceneList) {
      state.homeServeData.sceneList = sceneList
    },
    updataobjData(state, objData) {
      state.objData = objData
    }
  },
  actions: {
    ////使用方法：this.$store.dispatch('asyUpdataTitle',this.registerSubmitData.telePhone); ///异步提交用户的账号信息到仓库
    asyUpdataTitle(context, title) {
      context.commit('updataTitle', title)
    },
    asyUpdataControlPageType(context, controlPageType) {
      //定义导航栏样式的变量
      context.commit('updataControlPageType', controlPageType)
    },
    asyUpdataRegionSenceCount(context, regionSenceCount) {
      //提交区域页面的剩余未显示的数量  //（展开收起功能块）
      context.commit('updataRegionSenceCount', regionSenceCount)
    },
    asyUpdataHomeSenceCount(context, homeSenceCount) {
      //提交区域页面的剩余未显示的数量  //（展开收起功能块）
      context.commit('updataHomeSenceCount', homeSenceCount)
    },
    asyUpdataRegionShowPage(context, regionShowPage) {
      //当前显示区域信息  异步提交
      context.commit('updataRegionShowPage', regionShowPage)
    },
    asyUpdataConfigReturnPath(context, configReturnPath) {
      ////设置管理进入之前的页面路径，用于设置页面右上角的返回
      context.commit('updataConfigReturnPath', configReturnPath)
    },
    asyUpdatahomeSceneCount(context, homeSceneCount) {
      ///////（展开收起功能块）
      context.commit('updatahomeSceneCount', homeSceneCount)
    },
    asyUpdataregionSceneCount(context, regionSceneCount) {
      ///////（展开收起功能块）
      context.commit('updataregionSceneCount', regionSceneCount)
    },
    // asyUpdataServeData(context, ServeData) {
    //   context.commit('updataServeData', ServeData)
    // },
    // asyUpdataServeDatadeviceList(context, deviceList) {
    //   context.commit('updataServeDatadeviceList', deviceList)
    // },
    // asyUpdataServeDatasceneList(context, sceneList) {
    //   context.commit('updataServeDatasceneList', sceneList)
    // },
    asyUpdataregionServeData(context, regionServeData) {
      context.commit('updataregionServeData', regionServeData)
    },
    asyUpdataregionServeDatadeviceList(context, deviceList) {
      context.commit('updataregionServeDatadeviceList', deviceList)
    },
    asyUpdataregionServeDatasceneList(context, sceneList) {
      context.commit('updataregionServeDatasceneList', sceneList)
    },
    asyUpdatahomeServeData(context, homeServeData) {
      context.commit('updatahomeServeData', homeServeData)
    },
    asyUpdatahomeServeDatadeviceList(context, deviceList) {
      context.commit('updatahomeServeDatadeviceList', deviceList)
    },
    asyUpdatahomeServeDatasceneList(context, sceneList) {
      context.commit('updatahomeServeDatasceneList', sceneList)
    },
    asyUpdataobjData(context, objData) {
      context.commit('updataobjData', objData)
    }
  },
  modules: {}
}

export default publicinfo
